import SmazzoStesa from "./SmazzoStesa";

// Le Napoletane usano dritto + rovescio: stessa infrastruttura di caos fisico
// reale delle Vera Sibilla e delle Piacentine, con il mazzo napoletano reale.
export default function Napoletane() {
  return <SmazzoStesa deck="napoletane" />;
}
